<div class="family-member">
    <app-avatar class="user-avatar" [picture]="link.userId.picture" [size]="60"></app-avatar>
    <div class="row">
        <div class="col">
          <div class="row name">
            <div>{{ link.userId.firstName }} {{ link.userId.lastName }}</div>
          </div>
          <div *ngIf="link.link" class="row link">
            <div>
                <span>{{ 'pages.userFamily.link.' + link.link.toLowerCase() | translate }}</span>
                <span *ngIf="link.familyApproved && !link.cityApproved">{{ 'pages.userFamily.list.admin-pending' | translate }}</span>
            </div>
          </div>
          <div *ngIf="!link.familyApproved" class="row invitation-warning">
            <span class="icon-warning"></span>
            <span *ngIf="link.isSource">{{ 'pages.userFamily.invitationNotAccepted' | translate: { name: link.userId.firstName } }}</span>
            <span *ngIf="!link.isSource">{{ 'pages.userFamily.invitationNotAcceptedByCitizen' | translate: { name: link.userId.firstName } }}</span>
          </div>
        </div>
        <div class="col">
          <div class="action-button-wrapper">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <span class="icon-more-vertical"></span>
            </button>
            <mat-menu #menu="matMenu" class="family-member-menu">
              <!-- All family members / status -->
              <button mat-menu-item (click)="redirectToProfile(link.userId._id)">
                {{ 'pages.userFamily.button.view-profile-member' | translate }}
              </button>
              <!-- Current family members -->
              <ng-container *ngIf="link.cityApproved && link.familyApproved">
                <button mat-menu-item (click)="editFamilyLink(link)">
                  {{ 'pages.userFamily.button.edit-family-link' | translate }}
                </button>
                <button mat-menu-item class="danger" (click)="deleteFamilyLink(link)">
                  {{ 'pages.userFamily.button.remove-family-link' | translate }}
                </button>
              </ng-container>
              <!-- Pending invitations -->
              <ng-container *ngIf="!link.familyApproved">
                <button mat-menu-item class="info" (click)="forceAcceptFamilyLink(link)">
                  {{ 'pages.userFamily.button.force-accept' | translate }}
                </button>
              </ng-container>
              <!-- COMING SOON <ng-container *ngIf="!link.cityApproved && !link.familyApproved">
                <button mat-menu-item>
                  Resend invitation
                </button>
              </ng-container> -->
              <!-- All Pending -->
              <!-- COMING SOON <ng-container *ngIf="!link.cityApproved">
                <button mat-menu-item class="info">
                  View family link request
                </button>
              </ng-container> -->
            </mat-menu>
          </div>
        </div>
    </div>
  </div>